// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"product-form_wrapper_2BxJQ","stepper":"product-form_stepper_3SaHG","step":"product-form_step_6h9nX","controls":"product-form_controls_1TFba"};